// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_toolbar.styl
// module id = 221
// module chunks = 0